module.exports = __webpack_public_path__ + "img/My_Competencies.6cb5fea6.svg";